import BaseApi from "./baseApi";

class AdminApi extends BaseApi {
  async createCouple(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/admin/createCouple",
      data: data,
      method: "post",
    });
  }
  async deleteCouple(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/admin/deleteCouple",
      data: data,
      method: "post",
    });
  }

  async editCouple(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/admin/editCouple",
      data: data,
      method: "post",
    });
  }

  async getAllCouples(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/admin/getAllCouplesList",
      data: data,
      method: "post",
    });
  }

  async getAllCouplesSearch(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/admin/getAllCouplesSearch",
      data: data,
      method: "post",
    });
  }

  async getMissingData(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/admin/getMissingData",
      data: data,
      method: "get",
    });
  }

  async getCouplesDetail(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/admin/getCouplesDetail",
      data: data,
      method: "post",
    });
  }

  async searchKey(key: string): Promise<any> {
    return await this.API({
      url: `/admin/search/${key}`,
      method: "get",
    });
  }

  async makeCoupleAsSubAdmin(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/admin/makeCoupleAsSubAdmin",
      data: data,
      method: "post",
    });
  }

  async changeStatus(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/admin/changeStatus",
      data: data,
      method: "post",
    });
  }

  async saveCoupleExcel(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/admin/saveCoupleExcel",
      data: data,
      method: "post",
    });
  }

  async getStateCity(): Promise<any> {
    return await this.API({
      url: "/admin/getStateCity",
      method: "post",
    });
  }

  async participatedInRetreats(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/admin/participatedInRetreats",
      data: data,
      method: "post",
    });
  }

  async getAllAdmins(): Promise<any> {
    return this.API({
      url: "/admin/getAllAdmins",
      method: "get",
    });
  }

  async updateAdmins(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/admin/updateAdmins",
      data: data,
      method: "post",
    });
  }

  async retreatRegisteredCouples(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/admin/retreatRegisteredCouples",
      data: data,
      method: "post",
    });
  }

  async updateNewCoupleRegister(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/admin/updateNewCoupleRegister",
      data: data,
      method: "post",
    });
  }

  async couplesForCheck(): Promise<any> {
    return await this.API({
      url: "/admin/couplesForCheck",
      method: "get",
    });
  }

  async allCouples(): Promise<any> {
    return await this.API({
      url: "/auth/allCouples",
      method: "get",
    });
  }

  async saveCoupleImage(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/admin/saveCoupleImage",
      data: data,
      method: "post",
    });
  }

  async removeCoupleImage(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/admin/removeCoupleImage",
      data: data,
      method: "post",
    });
  }

  async outerUsers(): Promise<any> {
    return await this.API({
      url: "/auth/outerUsers",
      method: "get",
    });
  }

  async geAdminsAndSubAdmins(): Promise<any> {
    return await this.API({
      url: "/admin/geAdminsAndSubAdmins",
      method: "get",
    });
  }

  async updateUserRole(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/admin/updateUserRole",
      data: data,
      method: "post",
    });
  }

  async removeUserRole(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/admin/removeUserRole",
      data: data,
      method: "post",
    });
  }

  async changeAdminAccess(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/admin/changeAdminAccess",
      data: data,
      method: "post",
    });
  }

  async deleteCoupleFromRoaster(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/admin/deleteCoupleFromRoaster",
      data: data,
      method: "post",
    });
  }

  async sendLoginDetail(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/admin/send-login-detail",
      data: data,
      method: "post",
    });
  }

  async sendRegistrationPassword(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/registration-password/send",
      data: data,
      method: "post",
    });
  }

  async getOverview(data: Record<string, unknown> | object = {}): Promise<any> {
    return await this.API({
      url: "/admin/overview",
      data,
      method: "post",
    });
  }
}

export default AdminApi;
